var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.631592C9 0.631592 8.125 1.55264 8.125 2.60528V3.52016C4.8851 4.39365 2.5 7.46782 2.5 11.1579V17.5236L1.59912 20.3684H0V23H7.83936C7.62012 23.3997 7.50461 23.8531 7.50442 24.3146C7.50422 24.7762 7.61935 25.2297 7.83825 25.6296C8.05715 26.0295 8.37212 26.3618 8.75155 26.5931C9.13098 26.8244 9.56153 26.9466 10 26.9474C10.4389 26.9475 10.87 26.8259 11.2502 26.595C11.6303 26.3641 11.9459 26.0319 12.1654 25.6318C12.3849 25.2317 12.5004 24.7779 12.5005 24.3159C12.5005 23.8539 12.385 23.4001 12.1655 23H20V20.3684H18.4009L17.5 17.5236V11.1579C17.5 7.46782 15.1149 4.39365 11.875 3.52016V2.60528C11.875 1.55264 11 0.631592 10 0.631592ZM10 5.89475C12.8452 5.89475 15 8.16292 15 11.1579V17.9502L15.7642 20.3684H4.23584L5 17.9502V11.1579C5 8.16292 7.15476 5.89475 10 5.89475Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.01d1cd17a4353fff6f157e4c414e72a4.svg";
export { ForwardRef as ReactComponent };